import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import type { ProductOverrideInput, ResolvedProduct } from './types';

// Hooks des produits et de leurs surcharges (lot 3).

export function useProducts(search?: string) {
  return useQuery({
    queryKey: ['products', search ?? ''],
    queryFn: () => api.get<ResolvedProduct[]>(`/products${search ? `?search=${encodeURIComponent(search)}` : ''}`),
  });
}

export function useSaveOverride() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { ref: string; data: ProductOverrideInput }) =>
      api.put<ResolvedProduct>(`/products/${encodeURIComponent(input.ref)}/override`, input.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['products'] }),
  });
}

export function useDeleteOverride() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (ref: string) => api.del(`/products/${encodeURIComponent(ref)}/override`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['products'] }),
  });
}
